import { useState } from "react";
import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";
import { isSpaceMember } from "@/react/helpers/spaceHelpers";
import { useAddMemberModal } from "@circle-react/components/Modals/AddSpaceMember";
import {
  useCurrentSpaceContext,
  usePunditUserContext,
} from "@circle-react/contexts";
import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { useMobileWebFlags } from "@circle-react/hooks/useMobileWebFlags";
import { useSpaceApi } from "@circle-react/hooks/useSpaceApi";
import type { Space } from "@circle-react/types";
import { useSpaceCustomizationModal } from "../../SpaceCustomizationModal";
import { useCustomizeSpaceDeeplink } from "./useCustomizeSpaceDeeplink";

export const useManageSpaceActionsV3 = () => {
  const { currentCommunityMember } = usePunditUserContext();
  const [isCoverImageModalOpen, setIsCoverImageModalOpen] = useState(false);
  const { updateSpace } = useSpaceApi();
  const { data, refetch } = useCurrentSpaceContext();
  const addMemberModal = useAddMemberModal();
  const isSmScreen = useSmScreenMediaQuery();
  const spaceCustomizationMobileWebModal = useSpaceCustomizationModal();
  const { isMobileWebNewSpaceCustomizationUIEnabled } = useMobileWebFlags();
  const shouldRenderNewMobileWebUI =
    isSmScreen && isMobileWebNewSpaceCustomizationUIEnabled;

  const space = data;
  const spaceId = space?.id;
  const isAdmin = isCommunityAdmin(currentCommunityMember);
  const isMember = isSpaceMember(space);

  useCustomizeSpaceDeeplink();

  const onInviteMemberHandler = async () => {
    await addMemberModal.show({
      spaceId,
    });
  };

  const onSubmitCoverImage = async (space: Space) => {
    setIsCoverImageModalOpen(false);
    await updateSpace({ ...space, cover_image_visible: true }, spaceId);
    void refetch();
  };

  const onMobileSettingsClickHandler = () => {
    void spaceCustomizationMobileWebModal.show({
      space,
      onClickAddCoverImage: () => setIsCoverImageModalOpen(true),
      setIsAddMemberOpen: () => onInviteMemberHandler(),
    });
  };

  return {
    space,
    isAdmin,
    isMember,
    shouldRenderNewMobileWebUI,
    onInviteMemberHandler,
    onSubmitCoverImage,
    isCoverImageModalOpen,
    setIsCoverImageModalOpen,
    onMobileSettingsClickHandler,
  };
};
